import { useAppModal } from "@/context/AppModalContext";
import StoreBadges from "@/components/site/StoreBadges";
import { SITE } from "@/constants/testIds";

export default function Placeholder({ title, kicker, description }) {
  const { openModal } = useAppModal();
  return (
    <>
      <section className="pt-14 sm:pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-[color:var(--yn-primary)]">
            {kicker}
          </p>
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-[color:var(--yn-ink)]">
            {title}
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-[color:var(--yn-muted)]">
            {description ||
              "Detailed copy for this page will be added in the next pass. Every claim on this site is written against the approved claims sheet before it ships."}
          </p>

          <div className="mt-10">
            <StoreBadges
              placement={`placeholder-${(kicker || "").toLowerCase()}`}
              appTestId={SITE.heroAppStoreBadge}
              playTestId={SITE.heroPlayStoreBadge}
            />
          </div>

          <button
            type="button"
            onClick={() => openModal("placeholder")}
            className="mt-6 inline-flex items-center justify-center text-sm font-semibold text-white bg-[color:var(--yn-primary)] hover:bg-[color:var(--yn-primary-hover)] px-5 py-2.5 rounded-md"
          >
            Get the app
          </button>
        </div>
      </section>

      <section
        className="border-y border-[color:var(--yn-border)] bg-[color:var(--yn-subtle)]"
        data-testid={SITE.midBandSection}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
            <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[color:var(--yn-ink)]">
              Install it before you need it.
            </h2>
            <div className="md:justify-self-end">
              <StoreBadges
                placement="placeholder-mid-band"
                appTestId={SITE.midAppStoreBadge}
                playTestId={SITE.midPlayStoreBadge}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
